import { useContext } from 'react';
import { useQuery } from '@tanstack/react-query';
import { ROLES } from '@bb/users';
import { getSingleAccessEnabled } from 'api/SupraSystemSubscriptionController';
import { AuthContext } from 'contexts';

type Options = {
  /**
   * The user ID being viewed/edited. The hook returns false when:
   * - userId is empty/undefined
   * - the current user lacks admin role
   * - the current user is viewing their own profile
   */
  userId: string | undefined;
};

const useSingleAccessEnabled = ({ userId }: Options): boolean => {
  const { auth } = useContext(AuthContext);

  const isAdmin = ROLES[auth.role] >= ROLES.BRANCH_ADMIN;
  const isTargetingSelf = userId === auth.id;
  const isValidUser = Boolean(userId);

  const { data } = useQuery({
    queryKey: ['singleAccessEnabled', userId],
    queryFn: () => getSingleAccessEnabled({ userId: userId! }),
    enabled: isValidUser && isAdmin && !isTargetingSelf,
  });

  return data ?? false;
};

export default useSingleAccessEnabled;
